import './App.css';
import { Link } from 'react-router-dom';
import profileImage from './assets/Ervin_Puskar.png';

// Edit these values when contact details change.
export const CONTACT_EMAIL =
  process.env.REACT_APP_CONTACT_EMAIL || 'ervin.puskar@gmail.com';
export const EMAIL_LINK = `mailto:${CONTACT_EMAIL}`;
export const COMPANY_URL = 'https://100plus.com/';
export const GITHUB_URL = 'https://github.com/ervinMagic';
export const STACK_OVERFLOW_URL = 'https://stackoverflow.com/users/1720138/ervin';
export const SCHEDULE_CHAT_URL =
  process.env.REACT_APP_SCHEDULE_CHAT_URL ||
  'https://calendar.google.com/calendar/render?action=TEMPLATE&text=Chat%20with%20Ervin%20Pu%C5%A1kar&details=Networking%20chat%20with%20Ervin%20Pu%C5%A1kar&location=Google%20Meet';
export const PROFILE_IMAGE_URL = profileImage;

function SiteNav() {
  return (
    <header className="site-header">
      <nav className="site-nav" aria-label="Main navigation">
        <Link className="brand-link" to="/">
          Ervin Puškar
        </Link>

        <div className="nav-links">
          <Link to="/">Home</Link>
          <a href="/#about">About</a>
          <a href="/#connect">Connect</a>
          <details className="utilities-menu">
            <summary>Utilities</summary>
            <div className="utilities-menu-list">
              <Link to="/mbi">MBI Generator</Link>
              <Link to="/furdle">Wordle</Link>
            </div>
          </details>
        </div>
      </nav>
    </header>
  );
}

function ContactActions({ compact = false }) {
  return (
    <div className={compact ? 'contact-actions compact' : 'contact-actions'}>
      <a
        className="button primary"
        href={SCHEDULE_CHAT_URL}
        rel="noopener noreferrer"
        target="_blank"
      >
        Schedule a Chat
      </a>
      <a className="button secondary" href={EMAIL_LINK}>
        Email Me
      </a>
    </div>
  );
}

function ConversationIcon({ label, children }) {
  return (
    <div className="conversation-icon">
      <svg
        viewBox="0 0 96 96"
        role="img"
        aria-label={label}
        focusable="false"
      >
        {children}
      </svg>
    </div>
  );
}

function BurekIcon() {
  return (
    <ConversationIcon label="Bosnian pastry community icon">
      <circle cx="48" cy="48" r="31" />
      <ellipse cx="48" cy="50" rx="30" ry="14" />
      <path d="M20 48c9-8 18-12 28-12s19 4 28 12" />
      <path d="M20 50c8 10 17 15 28 15s20-5 28-15" />
      <path d="M48 20v56" />
      <path d="M25 35c10 4 18 9 23 15" />
      <path d="M71 35c-10 4-18 9-23 15" />
      <path d="M31 65c5-8 11-13 17-15" />
      <path d="M65 65c-5-8-11-13-17-15" />
    </ConversationIcon>
  );
}

function FamilyIcon() {
  return (
    <ConversationIcon label="Family icon">
      <circle cx="35" cy="27" r="8" />
      <circle cx="61" cy="27" r="8" />
      <circle cx="48" cy="45" r="6" />
      <path d="M25 72V47c0-8 5-13 12-13h2c7 0 12 5 12 13v25" />
      <path d="M45 72V50c0-8 5-13 12-13h2c7 0 12 5 12 13v22" />
      <path d="M37 72V58c0-6 4-10 10-10h2c6 0 10 4 10 10v14" />
      <path d="M32 52h10" />
      <path d="M54 52h10" />
    </ConversationIcon>
  );
}

function KettlebellIcon() {
  return (
    <ConversationIcon label="Kettlebell fitness icon">
      <path d="M34 38v-8c0-10 7-17 14-17s14 7 14 17v8" />
      <path d="M39 38v-7c0-6 4-10 9-10s9 4 9 10v7" />
      <path d="M29 43c0-5 4-9 9-9h20c5 0 9 4 9 9v23c0 10-8 18-18 18h-2c-10 0-18-8-18-18V43Z" />
      <path d="M35 75h26" />
    </ConversationIcon>
  );
}

function TechIcon() {
  return (
    <ConversationIcon label="Technology collaboration icon">
      <rect x="20" y="25" width="56" height="38" rx="4" />
      <path d="M14 72h68l-6-9H20l-6 9Z" />
      <path d="M41 39l-8 8 8 8" />
      <path d="M55 39l8 8-8 8" />
      <path d="M51 36l-6 22" />
    </ConversationIcon>
  );
}

function PathIcon() {
  return (
    <div className="path-icon path-icon-education">
      <svg
        viewBox="0 0 96 96"
        role="img"
        aria-label="Mathematics and management science background icon"
        focusable="false"
      >
        <path d="M18 68c10-18 18-27 30-27s20 9 30 27" />
        <path d="M22 68h52" />
        <path d="M31 61l9-16 11 16 13-24" />
        <path d="M25 28h46" />
        <path d="M31 28v15" />
        <path d="M48 28v15" />
        <path d="M65 28v15" />
        <path d="M23 20h50l-7 8H30l-7-8Z" />
      </svg>
    </div>
  );
}

function JourneyIcon() {
  return (
    <div className="path-icon path-icon-journey">
      <svg
        viewBox="0 0 96 96"
        role="img"
        aria-label="Journey from Bosnia to Kentucky icon"
        focusable="false"
      >
        <path d="M22 78V43l26-20 26 20v35" />
        <path d="M36 78V56h24v22" />
        <path d="M20 43h56" />
        <path d="M27 30c11-11 25-14 38-5" />
        <path d="M59 18l7 7-9 4" />
        <path d="M29 66h14" />
        <path d="M53 66h14" />
      </svg>
    </div>
  );
}

function CityIcon() {
  return (
    <div className="path-icon path-icon-city">
      <svg
        viewBox="0 0 96 96"
        role="img"
        aria-label="Starting career in New York icon"
        focusable="false"
      >
        <path d="M18 78h60" />
        <path d="M25 78V34h16v44" />
        <path d="M41 78V22h18v56" />
        <path d="M59 78V42h13v36" />
        <path d="M30 43h6" />
        <path d="M30 54h6" />
        <path d="M46 33h8" />
        <path d="M46 45h8" />
        <path d="M46 57h8" />
        <path d="M64 52h4" />
        <path d="M64 63h4" />
        <path d="M73 22l6 6-14 14" />
      </svg>
    </div>
  );
}

function SystemsIcon() {
  return (
    <div className="path-icon path-icon-systems">
      <svg
        viewBox="0 0 96 96"
        role="img"
        aria-label="Building useful technology icon"
        focusable="false"
      >
        <rect x="18" y="24" width="24" height="18" rx="4" />
        <rect x="54" y="24" width="24" height="18" rx="4" />
        <rect x="36" y="58" width="24" height="18" rx="4" />
        <path d="M42 33h12" />
        <path d="M48 42v16" />
        <path d="M30 42v8c0 5 4 8 9 8" />
        <path d="M66 42v8c0 5-4 8-9 8" />
        <path d="M43 67h10" />
      </svg>
    </div>
  );
}

const pathMilestones = [
  {
    title: 'Bosnia → Kentucky',
    text: 'Born in Banja Luka, Bosnia and raised in Bowling Green, Kentucky, I grew up with a mix of cultures, perspectives, and communities that continue to influence who I am today.',
    icon: <JourneyIcon />,
  },
  {
    title: 'MIT',
    text: "At MIT, I earned bachelor's degrees in Mathematics and Management Science with a focus in Finance, building a foundation in analytical thinking, problem solving, and understanding how organizations work.",
    icon: <PathIcon />,
  },
  {
    title: 'Starting My Career',
    text: 'I started my career in New York building financial technology systems, where I learned from talented teams and developed a deeper appreciation for reliable, scalable software.',
    icon: <CityIcon />,
  },
  {
    title: 'Building Useful Technology',
    text: 'Today, I design and build software systems across industries including healthcare technology, focusing on practical solutions that help people and organizations.',
    icon: <SystemsIcon />,
  },
];

function PathMilestone({ icon, title, text }) {
  return (
    <article className="path-milestone">
      {icon}
      <div>
        <h3>{title}</h3>
        <p>{text}</p>
      </div>
    </article>
  );
}

function ConversationCard({ icon, title, children, tone }) {
  return (
    <article className={`conversation-card ${tone}`}>
      {icon}
      <h3>{title}</h3>
      <p>{children}</p>
    </article>
  );
}

function App() {
  return (
    <div className="site-shell">
      <SiteNav />

      <main>
        <section className="hero-section" aria-labelledby="hero-title">
          <div className="hero-content">
            <p className="eyebrow">Bowling Green, Kentucky</p>
            <h1 id="hero-title">Hi, I&apos;m Ervin Puškar.</h1>
            <p className="hero-summary">
              I am a software architect based in Bowling Green, Kentucky,
              working across technology leadership and practical systems that
              include healthcare technology. I enjoy connecting with
              professionals across Kentucky, Nashville, and the
              Bosnian-American community.
            </p>
            <ContactActions />
          </div>

          <div className="hero-portrait-block">
            <img
              className="profile-image"
              src={PROFILE_IMAGE_URL}
              alt="Ervin Puškar"
            />
            <aside className="hero-note" aria-label="Professional focus">
              <p>Software architect and technology leader</p>
              <p>Healthcare technology and product-minded systems</p>
              <p>Bowling Green, Kentucky</p>
            </aside>
          </div>
        </section>

        <section id="about" className="content-section about-section">
          <div className="section-heading">
            <p className="eyebrow">About</p>
            <h2>Practical technology leadership with a personal touch.</h2>
          </div>
          <div className="section-copy">
            <p>
              My work sits at the intersection of software architecture,
              delivery, and leadership. I care about systems that are reliable,
              maintainable, and useful to the people depending on them.
            </p>
            <p>
              I have experience across healthcare technology and other software
              environments, with a bias toward practical problem solving, clear
              expectations, and building things that make real work easier.
            </p>
            <p>
              You can also find more context about one professional area I am
              connected to at{' '}
              <a href={COMPANY_URL} rel="noopener noreferrer" target="_blank">
                100Plus
              </a>
              .
            </p>
          </div>
        </section>

        <section className="path-section" aria-labelledby="path-title">
          <div className="path-card">
            <div className="path-content">
              <p className="eyebrow">My Path</p>
              <h2 id="path-title">How I got here.</h2>
              <p>A short version of the journey that shaped how I work and connect.</p>
            </div>
            <div className="path-timeline">
              {pathMilestones.map((milestone) => (
                <PathMilestone
                  key={milestone.title}
                  icon={milestone.icon}
                  title={milestone.title}
                  text={milestone.text}
                />
              ))}
            </div>
          </div>
        </section>

        <section className="connection-section" aria-labelledby="connection-title">
          <div className="section-heading">
            <p className="eyebrow">Shared Ground</p>
            <h2 id="connection-title">Easy ways to start a conversation.</h2>
          </div>

          <div className="connection-grid">
            <ConversationCard
              icon={<BurekIcon />}
              title="Bosnian-American Community"
              tone="warm-card"
            >
              I value meeting professionals across the community, especially
              across Kentucky and Nashville.
            </ConversationCard>
            <ConversationCard
              icon={<FamilyIcon />}
              title="Family"
              tone="community-card"
            >
              Family is central to how I think about priorities, time, and
              meaningful work.
            </ConversationCard>
            <ConversationCard
              icon={<KettlebellIcon />}
              title="Fitness and CrossFit"
              tone="energy-card"
            >
              I enjoy the discipline, consistency, and community that come with
              training.
            </ConversationCard>
            <ConversationCard
              icon={<TechIcon />}
              title="Technology Collaboration"
              tone="tech-card"
            >
              I am always interested in thoughtful conversations about
              architecture, teams, and useful products.
            </ConversationCard>
          </div>
        </section>

        <section id="connect" className="content-section connect-section">
          <div className="section-heading">
            <p className="eyebrow">Connect</p>
            <h2>Let&apos;s keep the conversation going.</h2>
          </div>
          <div className="section-copy">
            <p>
              If we met at a Bosnian-American professional networking event, or
              if you found this site through a shared connection, email me or
              schedule a short chat.
            </p>
            <p className="resume-note">Resume available upon request.</p>
            <div className="profile-links" aria-label="Professional developer profiles">
              <a href={GITHUB_URL} rel="noopener noreferrer" target="_blank">
                GitHub
              </a>
              <a href={STACK_OVERFLOW_URL} rel="noopener noreferrer" target="_blank">
                Stack Overflow
              </a>
            </div>
            <ContactActions compact />
          </div>
        </section>

        <section className="utilities-section" aria-labelledby="utilities-title">
          <div>
            <p className="eyebrow">Utilities</p>
            <h2 id="utilities-title">A couple of small tools still live here.</h2>
            <p>
              The original demo utilities are still available, just moved out of
              the spotlight.
            </p>
          </div>
          <div className="utility-links">
            <Link to="/mbi">MBI Generator</Link>
            <Link to="/furdle">Wordle</Link>
          </div>
        </section>
      </main>
    </div>
  );
}

export { SiteNav };
export default App;
